import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';

export interface TopBlockPropsType {
    disabled: boolean;
    disableEdit: boolean;
    filesError: boolean;
    handleImport: () => void;
    handleCarriers: () => void;
    orderType: string;
    setOrderType: (tab: string) => void;
    disableTabs: boolean;
}

const tabs = [
    { label: translate('orders.b2cOordes'), value: 'b2c' },
    { label: translate('orders.b2bOordes'), value: 'b2b' },
];

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                tabs={tabs}
                selectTab={props.orderType}
                onChangeTab={props.setOrderType}
                disableTabs={props.disableTabs}
                actions={[
                    {
                        label: translate('ordersImport.action.showCarriers'),
                        onClick: () => {
                            props.handleCarriers();
                        },
                        variant: 'outlined',
                    },
                    {
                        label: translate('ordersImport.action.import'),
                        onClick: () => {
                            props.handleImport();
                        },
                        disabled: props.disabled || props.disableEdit || props.filesError,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
